import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";
import styled from 'styled-components';
import {
  Table, Row, Cell
} from '../../components/table';
import { getRequest } from '../../../../api/ApiService';
import Auth from '../../../../routes/Auth';
import { Loader } from 'react-loaders';

const SubmittedButton = styled.div`
  width: 97px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #55b4bc;
  border-radius: 2px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  cursor: default;
`;

const NotSubmittedButton = styled.div`
  width: 97px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #ec5e59;
  border-radius: 2px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ec5e59;
  cursor: default;
`;

class ResultsAreInStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      result: {
        pd: false,
        pm: false,
        op: false,
        fn: false,
      },
      loaded: false,
    };
  }

  componentDidMount() {
    const { activeRound } = this.props;
    const keys = {
      pd: 'submit_development',
      pm: 'submit_marketing',
      op: 'submit_operations',
      fn: 'submit_finance'
    };

    getRequest(`${process.env.REACT_APP_API_URL}games/${Auth.getGameId()}/journal/?round_number=${activeRound}`)
      .then(res => {
        let result = {};
        let history = [
          ...res.body,
        ];
        history.sort((a, b) => {
          const dateA = new Date(a.requested_at);
          const dateB = new Date(b.requested_at);

          return dateB - dateA;
        });

        ['pd', 'pm', 'op', 'fn'].forEach(type => {
          result[type] = false;

          const obj = history.find(i => i.path === `/api/teams/${keys[type]}/`);
          if (obj && obj.response && typeof obj.response.success !== 'undefined') {
            result[type] = obj.response.success;
          }
        });

        this.setState({
          result,
          loaded: true,
        });
      })
      .catch(err => { });
  }

  render() {
    const { result, loaded } = this.state;

    return loaded ? (
      <OneVisualLayout
        section="RESULTS ARE IN!"
        title="Decision Not Submitted"
        paragraph1={(
          <Fragment>
            It looks like all of your team decisions were not successfully submitted.
            This could be due to your team either not making or submitting all decisions.
            You can always check submission status on <b>the CEO page</b>.
          </Fragment>
        )}
        visual={(
          <Fragment>
            <Table>
              <Row background="#2a4169">
                <Cell color="#ffffff">Department</Cell>
                <Cell color="#ffffff">Submission Status</Cell>
              </Row>
              <Row background="rgba(0, 27, 43, 0.02)">
                <Cell color="rgba(0, 27, 59, 0.94)">
                  Product Management
                </Cell>
                <Cell>
                  {result.pd && (
                    <SubmittedButton>
                      Submitted
                    </SubmittedButton>
                  )}
                  {!result.pd && (
                    <NotSubmittedButton>
                      Not Submitted
                    </NotSubmittedButton>
                  )}
                </Cell>
              </Row>
              <Row background="rgba(0, 27, 43, 0.02)">
                <Cell color="rgba(0, 27, 59, 0.94)">
                  Product Marketing
                </Cell>
                <Cell>
                  {result.pm && (
                    <SubmittedButton>
                      Submitted
                    </SubmittedButton>
                  )}
                  {!result.pm && (
                    <NotSubmittedButton>
                      Not Submitted
                    </NotSubmittedButton>
                  )}
                </Cell>
              </Row>
              <Row background="rgba(0, 27, 43, 0.02)">
                <Cell color="rgba(0, 27, 59, 0.94)">
                  Operations
                </Cell>
                <Cell>
                  {result.op && (
                    <SubmittedButton>
                      Submitted
                    </SubmittedButton>
                  )}
                  {!result.op && (
                    <NotSubmittedButton>
                      Not Submitted
                    </NotSubmittedButton>
                  )}
                </Cell>
              </Row>
              <Row background="rgba(0, 27, 43, 0.02)">
                <Cell color="rgba(0, 27, 59, 0.94)">
                  Finance
                </Cell>
                <Cell>
                  {result.fn && (
                    <SubmittedButton>
                      Submitted
                    </SubmittedButton>
                  )}
                  {!result.fn && (
                    <NotSubmittedButton>
                      Not Submitted
                    </NotSubmittedButton>
                  )}
                </Cell>
              </Row>
            </Table>
          </Fragment>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default ResultsAreInStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/results-are-in/step2.js